// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__36C9E","info":"UpdateTermsInfo_info__1B7Cm"};